import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

/**
 * Filter/action row above a table: wrapping flex row closed by a hairline.
 * `children` sit left; the `end` slot is pushed to the right edge.
 */
export function Toolbar({
  children,
  end,
  className,
}: {
  children: ReactNode
  end?: ReactNode
  className?: string
}) {
  return (
    <div className={cn('flex flex-wrap items-center gap-2 border-b border-rule/60 pb-3', className)}>
      {children}
      {end ? <div className="ml-auto flex flex-wrap items-center gap-2">{end}</div> : null}
    </div>
  )
}
